import { Button } from '@/ui'

const YES_NO_ANSWERS = ['Yes', 'No', 'Not sure'] as const

type YesNoAnswer = (typeof YES_NO_ANSWERS)[number]

const isYesNoAnswer = (value: unknown): value is YesNoAnswer =>
  YES_NO_ANSWERS.some((answer) => answer === value)

/** Only the answers the tool can give, so a stray result never puts words in the member's mouth. */
export const toYesNoAnswers = (result: object): YesNoAnswer[] =>
  'answers' in result && Array.isArray(result.answers)
    ? result.answers.filter(isYesNoAnswer)
    : []

interface YesNoButtonsProps {
  answers: YesNoAnswer[]
  onSend: (message: string) => void
}

export const YesNoButtons = ({ answers, onSend }: YesNoButtonsProps) => (
  <div className="my-2 flex items-center gap-2">
    {answers.map((answer) => (
      <Button
        key={answer}
        variant="secondary"
        size="sm"
        onClick={() => onSend(answer)}
      >
        {answer}
      </Button>
    ))}
  </div>
)
